import { Injectable } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { AnalyticsImplementation, AnalyticsPageType } from './analytics.service';
import { ConfigurationData } from '../config.service';
import { DisplayOptionsService } from '../display-options.service';
import { Identity, MemberInfo } from '../session-data';
import { SessionService } from '../session.service';

@Injectable({
  providedIn: 'root'
})
export class MetricService implements AnalyticsImplementation {

  constructor(
    private displayOptionsService: DisplayOptionsService,
    private sessionService: SessionService) {
    this.displayDate = '';
  }

  private displayDate: string;
  private appInsights: ApplicationInsights;

  public init(config: ConfigurationData): void {
    if (!config.appInsightsInstrumentationKey) {
      return;
    }

    this.appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: config.appInsightsInstrumentationKey,
      }
    });
    this.appInsights.loadAppInsights();
  }

  public recordEvent(eventName: string, context: any, data: any) {
    var appInsightsData = this.getAppInsightsData();
    appInsightsData.featureName = context;

    this.appInsights.trackEvent({
      name: eventName,
      properties: Object.assign({}, appInsightsData, data),
    });
  };

  public recordPageView(pageType: AnalyticsPageType, data: any) {
    var appInsightsData = this.getAppInsightsData();
    this.appInsights.trackPageView({
      name: pageType.toString(),
      pageType: pageType.toString(),
      properties: Object.assign({}, appInsightsData, data)
    });
  };

  public trackPageView(pageType: AnalyticsPageType, data: any) {
    //This is not implemented because we use ApplicationInsightsService for that
  };

  public recordException(exception: Error) {
    this.appInsights.trackException({ error: exception });
  };

  private getAppInsightsData(): any {
    let sessionData = this.sessionService.getSessionData();
    let displayOptions = this.displayOptionsService.getOptions();
    let identity = sessionData.identity || new Identity();
    let memberInfo = sessionData.memberInfo || new MemberInfo();

    return {
      agentId: sessionData.agentId,
      agentName: identity.ice_agent_name,
      countryCode: displayOptions.country_code,
      currencyCode: displayOptions.currency_code,
      eventDate: this.getLocalDate(),
      eventName: "car",
      locale: displayOptions.locale,
      memberClassId: identity.ice_member_class_id,
      memberId: memberInfo.member_id,
      nameId: sessionData.nameId,
      optsId: sessionData.optionsId,
      partnerId: sessionData.partnerId
    };
  }

  private getLocalDate(): string {
    if (this.displayDate.length == 0) {
      var today = new Date();
      this.displayDate += (today.getMonth() + 1) + "-" + today.getDate() + "-" + today.getFullYear();
    }
    return this.displayDate;
  };
}
